import React from "react";

const ConsumerTechIndustryLayout = () => {
    return (
        <div className="bg-white">

            {/* ================= HERO ================= */}
            <section className="bg-[#2f2a35] text-white">
                <div className="max-w-7xl mx-auto px-6 py-24 grid md:grid-cols-2 gap-10 items-center">
                    <div>
                        <span className="text-sm uppercase text-gray-300">Industries</span>
                        <h1 className="text-4xl md:text-5xl font-bold mt-4">
                            Consumer Technology
                        </h1>
                        <p className="mt-6 text-gray-200 max-w-xl">
                            Helping consumer technology brands create connected, intelligent,
                            and scalable digital experiences across the value chain.
                        </p>
                    </div>

                    <div>
                        <img
                            src="https://images.unsplash.com/photo-1511707171634-5f897ff02aa9"
                            alt="Consumer Technology"
                            className="rounded-xl shadow-lg"
                        />
                    </div>
                </div>
            </section>

            {/* ================= INTRO ================= */}
            <section className="py-20">
                <div className="max-w-5xl mx-auto px-6 text-gray-700 space-y-4">
                    <p>
                        Consumer technology companies operate in fast-moving, highly
                        competitive markets where speed, innovation, and experience define
                        success.
                    </p>
                    <p>
                        We enable organizations across retail, commerce, and consumer
                        platforms to modernize systems, unify experiences, and unlock
                        data-driven growth.
                    </p>
                </div>
            </section>

            {/* ================= RETAIL, COMMERCE & CPG ================= */}
            <section className="py-20">
                <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-3 gap-10">
                    <div className="md:col-span-2">
                        <h2 className="text-3xl font-bold mb-4">
                            Retail, Commerce, and CPG
                        </h2>
                        <p className="text-gray-700">
                            Build seamless omnichannel experiences with modern commerce
                            platforms, intelligent supply chains, and customer-centric digital
                            solutions.
                        </p>

                        <button className="mt-6 bg-orange-500 text-white px-6 py-3 rounded-md">
                            Learn more about our industry expertise
                        </button>
                    </div>

                    <div className="bg-[#020617] text-white rounded-xl p-6">
                        <h4 className="font-semibold mb-4">Our Offerings</h4>
                        <ul className="space-y-2 text-sm text-gray-300">
                            <li>• Digital Commerce Platforms</li>
                            <li>• Customer Experience Engineering</li>
                            <li>• Supply Chain Modernization</li>
                            <li>• Data & AI Enablement</li>
                            <li>• Cloud & Platform Engineering</li>
                        </ul>
                    </div>
                </div>
            </section>

            {/* ================= AGENTIC AI ================= */}
            <section
                className="py-24 text-white"
                style={{
                    backgroundImage:
                        "linear-gradient(rgba(2,6,23,.85), rgba(2,6,23,.85)), url(https://images.unsplash.com/photo-1581091012184-7b8bafc23c6c)",
                    backgroundSize: "cover",
                }}
            >
                <div className="max-w-7xl mx-auto px-6">
                    <h2 className="text-3xl font-bold">
                        Retail Agentic AI at Scale
                    </h2>
                    <p className="mt-4 max-w-xl text-gray-200">
                        Apply AI-driven automation and intelligent agents to enhance customer
                        engagement, optimize operations, and accelerate decision-making.
                    </p>
                </div>
            </section>

            {/* ================= CLIENT SUCCESS ================= */}
            <section className="py-20 bg-[#020617] text-white">
                <div className="max-w-7xl mx-auto px-6">
                    <h2 className="text-3xl font-bold mb-10">Client Success</h2>

                    <div className="grid md:grid-cols-3 gap-6">
                        {[
                            {
                                img: "https://images.unsplash.com/photo-1601597111158-2fceff292cdc",
                                tag: "Consumer Technology",
                                title:
                                    "Consumer tech leader accelerates digital commerce with scalable cloud platforms",
                            },
                            {
                                img: "https://images.unsplash.com/photo-1518770660439-4636190af475",
                                tag: "Smart Devices",
                                title:
                                    "IoT company enhances connected device performance through real-time analytics",
                            },
                            {
                                img: "https://images.unsplash.com/photo-1498050108023-c5249f4df085",
                                tag: "Digital Platforms",
                                title:
                                    "Global software brand improves user experience using AI-driven personalization",
                            },
                        ].map((item, i) => (
                            <div
                                key={i}
                                className="bg-white text-black rounded-xl overflow-hidden 
                     transform transition duration-300 hover:-translate-y-2 hover:shadow-2xl"
                            >
                                <img
                                    src={item.img}
                                    alt={item.title}
                                    className="w-full h-48 object-cover"
                                    loading="lazy"
                                />

                                <div className="p-5">
                                    <span className="text-xs font-semibold text-orange-600">
                                        {item.tag}
                                    </span>

                                    <p className="mt-2 font-medium leading-snug">
                                        {item.title}
                                    </p>

                                    <button className="mt-3 text-orange-600 text-sm font-medium hover:underline">
                                        Read the story →
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>


            {/* ================= SMART PRACTICE ================= */}
            <section className="py-20">
                <div className="max-w-7xl mx-auto px-6">
                    <h2 className="text-3xl font-bold mb-8">
                        Our Smart™ Practice
                    </h2>

                    <div className="grid md:grid-cols-4 gap-6">
                        {[
                            "Customer Data Platforms",
                            "Commerce Modernization",
                            "AI-Driven Personalization",
                            "Supply Chain Intelligence",
                        ].map((item) => (
                            <div
                                key={item}
                                className="bg-[#020617] text-white rounded-xl p-6 text-sm"
                            >
                                {item}
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* ================= SOLUTION ACCELERATORS ================= */}
            <section className="py-20 bg-gray-50">
                <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-10 items-center">
                    <div>
                        <h2 className="text-3xl font-bold mb-4">
                            Our Solution Accelerators
                        </h2>
                        <p className="text-gray-700">
                            Pre-built frameworks and accelerators designed to reduce time-to-market
                            and improve ROI for consumer technology initiatives.
                        </p>
                    </div>

                    <img
                        src="https://images.unsplash.com/photo-1518770660439-4636190af475"
                        alt="Solution Accelerators"
                        className="rounded-xl"
                    />
                </div>
            </section>

            {/* ================= NEWS ================= */}
            <section className="py-20 bg-[#020617] text-white">
                <div className="max-w-7xl mx-auto px-6">
                    <h2 className="text-3xl font-bold mb-10">News & Insights</h2>

                    <div className="grid md:grid-cols-3 gap-6">
                        {[
                            {
                                img: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f",
                                tag: "Blog",
                                title:
                                    "Driving next-generation consumer experiences through digital innovation",
                            },
                            {
                                img: "https://images.unsplash.com/photo-1519389950473-47ba0277781c",
                                tag: "Insight",
                                title:
                                    "How AI and automation are transforming modern enterprise operations",
                            },
                            {
                                img: "https://images.unsplash.com/photo-1492724441997-5dc865305da7",
                                tag: "Article",
                                title:
                                    "Cloud-first strategies enabling faster growth for global businesses",
                            },
                        ].map((item, i) => (
                            <div
                                key={i}
                                className="bg-white text-black rounded-xl overflow-hidden 
                     transform transition duration-300 hover:-translate-y-2 hover:shadow-2xl"
                            >
                                <img
                                    src={item.img}
                                    alt={item.title}
                                    className="w-full h-48 object-cover"
                                    loading="lazy"
                                />

                                <div className="p-5">
                                    <span className="text-xs font-semibold text-orange-600">
                                        {item.tag}
                                    </span>

                                    <p className="mt-2 font-medium leading-snug">
                                        {item.title}
                                    </p>

                                    <button className="mt-3 text-orange-600 text-sm font-medium hover:underline">
                                        Read the blog →
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>


            {/* ================= CONTACT ================= */}
            {/* <section className="py-20 bg-gray-50">
                <div className="max-w-7xl mx-auto px-6">
                    <h2 className="text-3xl font-bold mb-8">Contact us</h2>

                    <form className="grid md:grid-cols-2 gap-6">
                        <input className="border p-3 rounded" placeholder="First name" />
                        <input className="border p-3 rounded" placeholder="Last name" />
                        <input className="border p-3 rounded" placeholder="Work email" />
                        <input className="border p-3 rounded" placeholder="Company" />
                        <textarea
                            className="border p-3 rounded md:col-span-2"
                            rows="4"
                            placeholder="How can we help?"
                        />
                        <button className="bg-orange-500 text-white px-6 py-3 rounded-md">
                            Submit
                        </button>
                    </form>
                </div>
            </section> */}

        </div>
    );
};

export default ConsumerTechIndustryLayout;
